<template>
  <div class="flex items-center gap-x-3 mb-4">
    <AtomIcon icon-type="outline" icon-name="ViewGridIcon" color-variant="shy" />

    <AtomText
      :text="t('dashboard.usefulLinks.title')"
      font-size="text-lg"
      font-style="font-medium"
      data-cy="dashboard-links-title"
    />
  </div>

  <div class="grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-2">
    <MoleculeFrameCard
      v-for="(link, id) in USEFUL_LINKS"
      :key="id"
      data-cy="dashboard-link-wrapper"
    >
      <div class="flex items-center justify-between gap-x-3">
        <AtomText
          :text="t(link.label)"
          font-size="text-sm"
          font-style="font-medium"
          data-cy="dashboard-link-label"
        />

        <MoleculeButton
          icon-name="ExternalLinkIcon"
          variant="tertiary"
          size="xs"
          @clicked="goToUrl(link.url)"
        />
      </div>
    </MoleculeFrameCard>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import { USEFUL_LINKS } from '@/constants';

const { t } = useI18n();

const goToUrl = (url: string) => {
  window.open(url, '_blank');
};
</script>
